// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow: hidden;
  font-family: 'Roboto-Bold', sans-serif !important;
}

.app {
  display: flex;
  flex: 1 1;
  min-height: 100vh;
}

.rnc__notification-container--center {
  z-index: 10003;
}

.innerScreenContainer {
  min-height: calc(100vh - 100px);
  width: calc(100vw - 200px);
  background-color: #ffffff;
  overflow-y: scroll;
}

.formButtons {
  display: flex;
  flex-direction: row;
  margin-top: 40px;
  margin-bottom: 40px;
  margin-left: 20px;
  margin-right: 20px;
  justify-content: flex-end;
}

.screenTitleContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: 16px;
  margin-right: 8px;
}

.screenTitleContainerRow {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.screenTitleText {
  font-size: 20px;
  color: #e51b22;
  text-transform: uppercase;
  font-weight: 700;
  margin-right: 20px;
}

.screenTitleTextIcon {
  font-size: 30px;
  color: #e51b22;
  margin-right: 20px;
  cursor: pointer;
}

.statusButtons {
  display: flex;
  flex-direction: row;
  background-color: #e1e2e5;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  box-shadow: 0px 0px 6px 0px rgba(163, 164, 167, 1);
  margin-left: 16px;
  margin-right: 8px;
}

.statusButton {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 30px;
  padding-left: 30px;
  cursor: pointer;
  font-size: 20px;
}

.statusButtonActive {
  color: #e51b22;
  border-bottom: 4px solid #e51b22;
}

.bottomStatusButtons {
  display: flex;
  flex-direction: row;
  background-color: #e1e2e5;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  margin-left: 16px;
  margin-right: 8px;
  box-shadow: 0px 0px 6px 0px rgba(163, 164, 167, 1);
}

.nestedScreenTitle {
  font-size: 20px;
  color: #e51b22;
  text-transform: uppercase;
  font-weight: 700;
}

.errorMessage {
  font-size: 14px;
  color: #e51b22;
  margin: 20px;
}

.MTableToolbar-title-9 {
  width: 100%;
}

.MTableToolbar-spacer-7 {
  display: none;
}

.MuiTextField-root.MTableToolbar-searchField-10 {
  position: absolute; 
  top: 100px;
  right: 30px;
}

.nestedInnerTable div.MuiToolbar-root div.MuiFormControl-root.MuiTextField-root.MTableToolbar-searchField-10{
  top: -45px;
  z-index: 1000;
}

.MTableToolbar-root-5 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.Component-horizontalScrollContainer-12 {
  border: 1px solid #e1e2e5;
  border-top: none;
  margin-left: 16px;
  margin-right: 8px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: 0px 6px 10px 0px rgba(163, 164, 167, 1);
}

.MuiTableSortLabel-root {
  font-weight: 700;
}

.MuiTableCell-root {
  border-bottom: none !important;
  padding: 10px !important;
}

.deviceManagementTable .MuiTableCell-root {
  padding-bottom: 5px !important;
  padding-top: 5px !important;
}

.MuiPaper-elevation2 {
  box-shadow: none !important;
}

.MuiPaper-root {
  margin-bottom: 50px;
}

.halfWidth {
  width: 50%;
}

.MuiToolbar-regular {
  min-height: 0 !important;
}

.userInformationLabel {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.userInformationLabelText {
  font-size: 16px;
  line-height: 30px;
}

.userInformationAvatar {
  margin-right: 10px;
  border-radius: 30px;
  height: 30px;
  width: 30px;
}

.spaceBetween {
  justify-content: space-between;
}

.rnc__notification-content {
  text-align: center;
}

.rnc__notification-item {
  border-left: none !important;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAG3B,kDAAkD;EAClD,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EAGjB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,8BAA8B;EAG9B,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["body {\n  overflow: hidden;\n  font-family: 'Roboto-Bold', sans-serif !important;\n}\n\n.app {\n  display: flex;\n  flex: 1;\n  min-height: 100vh;\n}\n\n.rnc__notification-container--center {\n  z-index: 10003;\n}\n\n.innerScreenContainer {\n  min-height: calc(100vh - 100px);\n  width: calc(100vw - 200px);\n  background-color: #ffffff;\n  overflow-y: scroll;\n}\n\n.formButtons {\n  display: flex;\n  flex-direction: row;\n  margin-top: 40px;\n  margin-bottom: 40px;\n  margin-left: 20px;\n  margin-right: 20px;\n  justify-content: flex-end;\n}\n\n.screenTitleContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 30px;\n  margin-left: 16px;\n  margin-right: 8px;\n}\n\n.screenTitleContainerRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.screenTitleText {\n  font-size: 20px;\n  color: #e51b22;\n  text-transform: uppercase;\n  font-weight: 700;\n  margin-right: 20px;\n}\n\n.screenTitleTextIcon {\n  font-size: 30px;\n  color: #e51b22;\n  margin-right: 20px;\n  cursor: pointer;\n}\n\n.statusButtons {\n  display: flex;\n  flex-direction: row;\n  background-color: #e1e2e5;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  -webkit-box-shadow: 0px 0px 6px 0px rgba(163, 164, 167, 1);\n  -moz-box-shadow: 0px 0px 6px 0px rgba(163, 164, 167, 1);\n  box-shadow: 0px 0px 6px 0px rgba(163, 164, 167, 1);\n  margin-left: 16px;\n  margin-right: 8px;\n}\n\n.statusButton {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  padding-right: 30px;\n  padding-left: 30px;\n  cursor: pointer;\n  font-size: 20px;\n}\n\n.statusButtonActive {\n  color: #e51b22;\n  border-bottom: 4px solid #e51b22;\n}\n\n.bottomStatusButtons {\n  display: flex;\n  flex-direction: row;\n  background-color: #e1e2e5;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  margin-left: 16px;\n  margin-right: 8px;\n  -webkit-box-shadow: 0px 0px 6px 0px rgba(163, 164, 167, 1);\n  -moz-box-shadow: 0px 0px 6px 0px rgba(163, 164, 167, 1);\n  box-shadow: 0px 0px 6px 0px rgba(163, 164, 167, 1);\n}\n\n.nestedScreenTitle {\n  font-size: 20px;\n  color: #e51b22;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.errorMessage {\n  font-size: 14px;\n  color: #e51b22;\n  margin: 20px;\n}\n\n.MTableToolbar-title-9 {\n  width: 100%;\n}\n\n.MTableToolbar-spacer-7 {\n  display: none;\n}\n\n.MuiTextField-root.MTableToolbar-searchField-10 {\n  position: absolute; \n  top: 100px;\n  right: 30px;\n}\n\n.nestedInnerTable div.MuiToolbar-root div.MuiFormControl-root.MuiTextField-root.MTableToolbar-searchField-10{\n  top: -45px;\n  z-index: 1000;\n}\n\n.MTableToolbar-root-5 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.Component-horizontalScrollContainer-12 {\n  border: 1px solid #e1e2e5;\n  border-top: none;\n  margin-left: 16px;\n  margin-right: 8px;\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px;\n  -webkit-box-shadow: 0px 6px 10px 0px rgba(163, 164, 167, 1);\n  -moz-box-shadow: 0px 6px 10px 0px rgba(163, 164, 167, 1);\n  box-shadow: 0px 6px 10px 0px rgba(163, 164, 167, 1);\n}\n\n.MuiTableSortLabel-root {\n  font-weight: 700;\n}\n\n.MuiTableCell-root {\n  border-bottom: none !important;\n  padding: 10px !important;\n}\n\n.deviceManagementTable .MuiTableCell-root {\n  padding-bottom: 5px !important;\n  padding-top: 5px !important;\n}\n\n.MuiPaper-elevation2 {\n  box-shadow: none !important;\n}\n\n.MuiPaper-root {\n  margin-bottom: 50px;\n}\n\n.halfWidth {\n  width: 50%;\n}\n\n.MuiToolbar-regular {\n  min-height: 0 !important;\n}\n\n.userInformationLabel {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.userInformationLabelText {\n  font-size: 16px;\n  line-height: 30px;\n}\n\n.userInformationAvatar {\n  margin-right: 10px;\n  border-radius: 30px;\n  height: 30px;\n  width: 30px;\n}\n\n.spaceBetween {\n  justify-content: space-between;\n}\n\n.rnc__notification-content {\n  text-align: center;\n}\n\n.rnc__notification-item {\n  border-left: none !important;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
